import React, { useState, useEffect } from 'react';
import '../view-archer-styles.css';

// material-ui: theme, colors, icons
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, MenuItem, InputLabel, Select, Stack} from '@mui/material/';

//const data
import AuditPeriods from '../../../data/AuditPeriods';

interface ReconcilationDialogProps {
    cpfId: number,
    isReconcilationDialogOpen: boolean,
    closeReconcilationDialog: () => void,
    getReconcilationHtml: (html: string) => void
}

const IssueReconcilationDialog = (props: ReconcilationDialogProps) => {

    //initial state set up
    let defaultReportYear = 2025;
    let defaultReportMonth = 1

    const [reportYear, setReportYear] = useState(defaultReportYear);
    const [startPeriod, setStartPeriod] = useState(defaultReportMonth);
    const [endPeriod, setEndPeriod] = useState(defaultReportMonth);
    const [reconcilationHtml, setReconcilationHtml] = useState('');

    const updateReportYear = (event: any) => {
        setReportYear(event.target.value);
    }

    const updateStartPeriod = (event: any) => {
        setStartPeriod(event.target.value);
    }

    const updateEndPeriod = (event: any) => {
        setEndPeriod(event.target.value);
    }


    const getBankReconciliation = () => {
        var params = [
            `cpfId=${props.cpfId}`,
            `startYear=${reportYear}`,
            `endYear=${reportYear}`,
            `startBankPeriodId=${startPeriod}`,
            `endBankPeriodId=${endPeriod}`
        ].join('&');

        let url = `/Archer3/GetBankReconciliation?${params}`;
        fetch(url)
            .then(result => result.text())
            .then(result => {
                let data = result;
                setReconcilationHtml(data);
                props.getReconcilationHtml(reconcilationHtml);
            })
    }

    return (
        <>
            <Dialog
                open={props.isReconcilationDialogOpen}
                onClose={props.closeReconcilationDialog}
            >
                <DialogTitle>Insert Reconcilation Table...</DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Stack direction="row" spacing={1} sx={{ marginTop: 1 }}>
                            <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                                <InputLabel>Report Year</InputLabel>
                                <Select
                                    defaultValue={defaultReportYear}
                                    label="Reporting Year"
                                    onChange={(event) => updateReportYear(event)}
                                >
                                    <MenuItem value={2026}>2026</MenuItem>
                                    <MenuItem value={2025}>2025</MenuItem>
                                    <MenuItem value={2024}>2024</MenuItem>
                                    <MenuItem value={2023}>2023</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                                <InputLabel>Start Period</InputLabel>
                                <Select
                                    defaultValue={defaultReportMonth}
                                    label="Start Period"
                                    onChange={(event) => updateStartPeriod(event)}
                                >
                                    {
                                        AuditPeriods.map((period) =>
                                            <MenuItem key={period.id} value={period.id}>{period.description}</MenuItem>
                                            )
                                    }
                                </Select>
                            </FormControl>
                            <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                                <InputLabel>End Period</InputLabel>
                                <Select
                                    defaultValue={defaultReportMonth}
                                    label="End Period"
                                    onChange={(event) => updateEndPeriod(event)}
                                >
                                    {
                                        AuditPeriods.map((period) =>
                                            <MenuItem key={period.id} value={period.id}>{period.description}</MenuItem>
                                        )
                                    }
                                </Select>
                            </FormControl>
                        </Stack>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.closeReconcilationDialog}>Cancel</Button>
                    <Button onClick={getBankReconciliation}>Insert</Button>
                </DialogActions>
            </Dialog>
        </>
        )
   
}

export default IssueReconcilationDialog;